var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosearrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0635 3.83456L10.5523 4.32331L7.68766 7.18794L10.5523 10.0526L10.0635 10.5413L7.1989 7.67669L4.3207 10.5549L3.83194 10.0661L6.71015 7.18794L3.83194 4.30973L4.3207 3.82098L7.1989 6.69919L10.0635 3.83456Z",
    fill: "#F2EADF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosearrow);
export default __webpack_public_path__ + "static/media/closearrow.33d219202956636c0ebb43332f3dcd5e.svg";
export { ForwardRef as ReactComponent };